import { useState } from "react";
import * as userTableStyles from "@clientFrontend/features/scout/components/UserTable/styles.css";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

export type ActionedWorks = {
  type: string;
  workNames: string[];
};

export type ActionedWorksProps = {
  actionedWorks: ActionedWorks;
  containerClassName?: string;
};

export const ActionedWorksInfo = (props: ActionedWorksProps) => {
  const { actionedWorks, containerClassName } = props;

  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <tr key={actionedWorks.type} className={containerClassName ?? ""}>
        <td colSpan={6} className={`${userTableStyles.td} ${userTableStyles.fullColTr}`}>
          <div className={userTableStyles.fullColTrContent}>
            <b>{actionedWorks.type}</b>
            <div className={styles.workNamesContainer}>
              {isOpened ? (
                actionedWorks.workNames.map((workName) => <p key={workName}>{workName}</p>)
              ) : (
                <p>{actionedWorks.workNames[0]}</p>
              )}
            </div>
            {actionedWorks.workNames.length > 1 && (
              <div className={styles.toggleButtonContainer}>
                <button
                  type="button"
                  aria-expanded={isOpened}
                  onClick={() => setIsOpened((prev) => !prev)}
                  className={styles.toggleButton}
                >
                  {isOpened ? (
                    <>
                      <Icon name="arrow-bold-up" />
                      <span>閉じる</span>
                    </>
                  ) : (
                    <>
                      <Icon name="arrow-bold-down" />
                      <span>もっと見る</span>
                    </>
                  )}
                </button>
              </div>
            )}
          </div>
        </td>
      </tr>
    </>
  );
};
